import { render } from "./SubRegisterForm.vue?vue&type=template&id=546ee3e9"
import script from "./SubRegisterForm.vue?vue&type=script&lang=js"
export * from "./SubRegisterForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/test/Documents/GitHub/LpMooveTrainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__